<template>
	<div class="avatar-item-selector" :class="{ disabled }" @click="isOpen = ! disabled">
		<ximg
			v-if="equippedItem"
			class="pixelated avatar-slot-icon"
			:src="'/api/avatar/preview/' + equippedItem.id"
			:ariaLabel="equippedItem.name"
			role="img"
		/>
		<ximg
			v-else-if="placeholderIconUrl"
			class="avatar-slot-icon"
			:src="placeholderIconUrl"
			:ariaLabel="label"
			role="img"
		/>
		<div class="pull-left hidden-xs item-content">
			<div class="ell-wrap">
				<div class="item-type ell">
					{{ label }} <span class="new-text" v-if="hasNew">{{ t('NEW') }}</span>
				</div>
			</div>
			<div class="ell-wrap">
				<div class="equipped-item-name ell" v-if="equippedItem">
					{{ equippedItem.name }}
				</div>
			</div>
		</div>

		<modal container-class="avatar-item-modal" v-model="isOpen">
			<div class="equipped-item-header">
				<div class="avatar-item-showcase-box">
					<ximg
						:src="equippedItem ? '/api/avatar/preview/' + equippedItem.id : convertToCdnUrl('/img/icons/remove.svg')"
						class="pixelated"
						:ariaLabel="equippedItem ? equippedItem.name + ' equipped' : 'nothing equipped'"
						role="img"
					/>
				</div>
				<h2 class="level-one-heading">
					{{ equippedItem ? equippedItem.name : '' }}
				</h2>
			</div>
			<div class="avatar-item-showcase">
				<div
					:class="['avatar-item-showcase-box', { equipped: equippedItem === null }]"
					title="Ta bort"
					@click="select(null)"
				>
					<ximg
						:src="convertToCdnUrl('/img/icons/remove.svg')"
						ariaLabel="Ta bort"
						role="img"
					/>
				</div>
				<div
					v-for="item in availableItems"
					:key="'bp-' + item.bodyPart + '-id-' + item.id"
					:class="['avatar-item-showcase-box', { equipped: equippedItem === item }]"
					:title="item.name"
					@click="select(item)"
				>
					<ximg
						:src="'/api/avatar/preview/' + item.id"
						class="pixelated"
						:ariaLabel="item.name"
						role="img"
					/>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import { t } from 'datastore/i18n';
import { convertToCdnUrl } from 'utils';

export default {
	props: ['label', 'area', 'items', 'equippedItems', 'disabled'],
	data () {
		return {
			isOpen: false,
		};
	},
	computed: {
		placeholderIconUrl () {
			let area;
			if (Array.isArray(this.area)) {
				area = this.area[0];
				console.log(this.area, 'area');
			} else {
				area = ~~this.area;
			}
			const clothes = {
				1: 'mantel',
				3: 'skor',
				4: 'byxor',
				5: 'overkropp',
				6: 'axlar',
				7: 'har',
				8: 'hjalm',
				10: 'vapen',
				11: 'skold',
			};
			const name = clothes[area];
			if (name) {
				return '/img/member/hattvaljaren_' + name + '.svg';
			}
			return false;
		},
		availableItems () {
			if (Array.isArray(this.area)) {
				return this.items.filter(item => {
					return this.area.includes(item.bodyPart);
				});
			}
			const area = ~~this.area;
			return this.items.filter(item => {
				return area === item.bodyPart;
			});
		},
		equippedItem () {
			for (const i in this.availableItems) {
				if (this.equippedItems.includes(this.availableItems[i].id)) {
					return this.availableItems[i];
				}
			}
			return null;
		},
		btnTitle () {
			return 'Välj ' + this.label.toLowerCase();
		},
		checkId () {
			return 'avatar-item-selector-' + this._uid;
		},
		hasNew () {
			for (const k in this.availableItems) {
				if (this.availableItems[k].unlockedAt > (Date.now() / 1000) - 60 * 60 * 24 * 7) {
					return true;
				}
			}
			return false;
		},
	},
	methods: {
		t,
		convertToCdnUrl,
		isNew (item) {
			return item.unlockedAt > (Date.now() / 1000) - 60 * 60 * 24 * 7;
		},
		select (item) {
			this.$emit('equip', item, this.area);
		},
	},
};
</script>
